// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"763":"21d6586e","891":"0803c42b","983":"0803c42b"}[chunkId] + ".chunk.css";
};